import { Badge } from '@/components/ui/badge';
import { Zap } from 'lucide-react';
import { EmptyState } from './shared';

export function BoostsTab({ boostDetails }) {
  if (boostDetails.length === 0) return <EmptyState icon={Zap} text="Aucun boost achete" />;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b dark:border-neutral-700 text-left text-xs text-neutral-500 uppercase tracking-wide">
            <th className="pb-3 pr-4">Annonce</th>
            <th className="pb-3 pr-4">Vendeur</th>
            <th className="pb-3 pr-4">Type</th>
            <th className="pb-3 pr-4">Montant</th>
            <th className="pb-3 pr-4">Statut</th>
            <th className="pb-3 pr-4">Date</th>
            <th className="pb-3">Expiration</th>
          </tr>
        </thead>
        <tbody>
          {boostDetails.map((b, i) => {
            const isActive = b.expires_at && new Date(b.expires_at) > new Date();
            return (
              <tr key={i} className="border-b dark:border-neutral-700/50 hover:bg-neutral-50 dark:hover:bg-neutral-800" data-testid={`boost-row-${i}`}>
                <td className="py-3 pr-4 font-medium text-neutral-900 dark:text-white">{b.listing_title}</td>
                <td className="py-3 pr-4"><span className="text-neutral-700 dark:text-neutral-300">{b.seller_name}</span><br /><span className="text-xs text-neutral-400">{b.company_name}</span></td>
                <td className="py-3 pr-4"><Badge className={`text-[10px] ${b.boost_type === 'homepage' ? 'bg-purple-100 text-purple-700' : b.boost_type === 'search_top' ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}`}>{b.boost_type}</Badge></td>
                <td className="py-3 pr-4 font-semibold text-emerald-600">{((b.amount_paid || 0) / 100).toFixed(2)}€</td>
                <td className="py-3 pr-4"><Badge className={isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-neutral-100 text-neutral-500'}>{isActive ? 'Actif' : 'Expire'}</Badge></td>
                <td className="py-3 pr-4 text-xs text-neutral-500">{b.created_at ? new Date(b.created_at).toLocaleDateString('fr-FR') : '-'}</td>
                <td className="py-3 text-xs text-neutral-500">{b.expires_at ? new Date(b.expires_at).toLocaleDateString('fr-FR') : '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
